import React from "react";
import styles from "./styles.m.css";
import PropTypes from "prop-types";

class StoryMidPromotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: "F"
    };
  }

  componentDidMount() {
    global.userPromise.catch(() => null).then(user => {
      user && this.setState({ userType: user.userType });
    });
  }

  render() {
    const { userType } = this.state;

    return (
      <React.Fragment>
        {userType === "P" || userType === "T" || userType === "R" ? null : (
          <div className={`${styles["midcontent-ot"]}`}>
            <ev-engagement group-name="Subscription" />
          </div>
        )}
      </React.Fragment>
    );
  }
}

StoryMidPromotion.propTypes = {
  story: PropTypes.shape()
};

export default StoryMidPromotion;
